import React, { useEffect, useState } from "react";
import { Button } from "../../Button/index";
import { Icon } from "../../../components/Layout/icons/index";
import { helpers, storage } from "../../../services";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { useNavigate } from "react-router-dom";
import Actions from "../../../store/actions";
import ModulesActions from "modules/entity/actions";
import Avatar from "assets/images/svg/avatar6.svg";
import outsideClick from "../../../hooks/OutsideClick";
import DownArrow from "assets/images/icons/arrow-down.svg";
import { Modal } from "../../index";
import PaymentModal from "components/Layout/Header/paymentModal";
import CurrensySettings from "components/Layout/Header/currencySettingsModal";
import i18next from "i18next";
import systemActions from "store/actions/system";
import useTranslations from "../../../hooks/useTranslation";
import WarningIcon from "../../../assets/images/icons/warning.svg";
import { Grid } from "antd";
import { BalanceWithAccount } from "components/Layout/Header/balance-with-account";
import "./style.scss";
import "./new-header.scss";

const { useBreakpoint } = Grid;
export function NewHeader() {
	const currentLangCode = useSelector(state => state.system.currentLangCode);
	const profile = useSelector(state => state.auth.user);
	const { langCodes } = useSelector(state => state.system);
	const currentLangTitle = langCodes.find(l => l.code === currentLangCode);

	const { tr } = useTranslations();

	const organizations = get(profile, "organizations", []);
	const activeOrganization = get(profile, "organization");
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { ref: langRef, isVisible: isLangOpen, setIsVisible: setIsLangOpen } = outsideClick(false);
	const [paymentModal, showPaymentModal] = useState(false);
	const [currencySettingsModal, showCurrencySettingsModal] = useState(false);
	const [currencyInfo, setCurrencyInfo] = useState([]);
	const [mergedRates, setMergedRates] = useState([]);
	const [canUpdate, setCanUpdate] = useState(false);
	const screen = useBreakpoint();

	const changeLang = langCode => {
		i18next.changeLanguage(langCode.code);
		dispatch(systemActions.ChangeLanguage(langCode.code));
	};
	const logoutHandler = () => {
		storage.remove("token");
		window.location.reload();
	};
	const lockHandler = () => {
		storage.set("lock_phone", get(profile, "phone"));
		storage.remove("token");
		navigate("/unlock");
		dispatch(Actions.auth.SetToken.request(null));
	};

	const balance = Number(
		get(activeOrganization, "balance", 0) ? activeOrganization.balance : 0
	);

	const mergeCurrencyRatesWithCBU = (localRates = [], cbuRates = []) => {
		const localMap = new Map(
			localRates.map(item => [item.ccy.toUpperCase(), item])
		);

		return cbuRates
			.filter(item => localMap.has(item.Ccy))
			.map(item => ({
				...item,
				local: localMap.get(item.Ccy)
			}));
	};

	useEffect(() => {
		dispatch(
			ModulesActions.LoadDefault.request({
				url: `/currency-rates`,
				cb: {
					success: data => {
						setCurrencyInfo(data.data);
					},
					error: data => { }
				}
			})
		);
	}, [canUpdate]);

	useEffect(() => {
		fetch("https://cbu.uz/uz/arkhiv-kursov-valyut/json/")
			.then(res => res.json())
			.then(data => {
				setMergedRates(mergeCurrencyRatesWithCBU(currencyInfo, data));
			})
			.catch(err => {
				console.error("Xato:", err);
			});
	}, [canUpdate, currencyInfo]);

	return (
		<>
			<Modal
				size={500}
				isOpen={paymentModal}
				toggle={() => showPaymentModal(false)}
			>
				<PaymentModal showPaymentModal={showPaymentModal} />
			</Modal>
			<Modal
				size={1000}
				isOpen={currencySettingsModal}
				toggle={() => showCurrencySettingsModal(false)}
			>
				<CurrensySettings {...{ currencyInfo, mergedRates, setCanUpdate }} />
			</Modal>
			<header className="header new-header !relative !w-full !p-0 !left-0 !px-1 lg:!px-0">
				{/* {screen.lg ? (
					<span className="header-corner !left-[-1px] !top-[65.5px]" />
				) : null} */}

				{/* <div className="header-wrapper !mb-0"> */}
				{/* {screen.lg ? ( */}
				<div className="new-header__toolbar d-flex align-items-center text-end justify-between">
					<div className="flex new-header__left min-w-0">
						<Button
							size="md"
							variant="filled"
							className="header-back"
							onClick={() => navigate(-1)}
						>
							<Icon icon="arrow-right" className="h-4 w-4" />
						</Button>
						{organizations.length > 1 && (
							<div
								className={`company-name new-header__org flex items-center min-w-0 px-1 lg:px-3 ml-[30px]`}
								onClick={() => {
									if (organizations.length > 1) {
										dispatch(Actions.system.ToggleOrganizationModal(true));
									}
									dispatch(Actions.system.ToggleOrganizationModal(true));
								}}
							>
								<div className="d-flex align-items-center w-full !text-sm">
									{get(activeOrganization, "name")}
									{organizations.length > 1 && (
										<img src={DownArrow} alt="" className="ml-15" />
									)}
								</div>
							</div>
						)}
					</div>
					<div className="flex justify-end new-header__right min-w-0">
						{currencyInfo.length > 0 && (
							<div
								className="company-name new-header__currency"
								onClick={() => showCurrencySettingsModal(true)}
								title={tr("Нажмите для подробностей")}
								role="button"
							>
								<div className="currency-grid new-header__currency-full">
									{currencyInfo.map((currency, cIdx) => (
										<div className="currency-row" key={get(currency, "ccy", `c-${cIdx}`)}>
											<span className="label">1 {get(currency, "ccy")}</span>
											<span className="value">{helpers.formatNumber(get(currency, "rate"))} UZS</span>
										</div>
									))}
								</div>
								<div className="new-header__currency-compact">
									<span className="new-header__currency-compact-text">{tr("Курсы")}</span>
									<span className="new-header__currency-compact-badge">{currencyInfo.length}</span>
								</div>
							</div>
						)}
						{balance < 0 ? (
							<button
								type="button"
								title={tr("Пополните свой баланс")}
								aria-label={tr("Пополните свой баланс")}
								className="new-header__balance-warn d-btn d-btn-warning d-btn--medium text-left"
								onClick={() => {
									showPaymentModal(true);
								}}
							>
								<img src={WarningIcon} alt="" className="new-header__balance-warn-icon" />
								<span className="new-header__balance-warn-label">{tr("Пополните свой баланс")}</span>
							</button>
						) : (
							<></>
						)}
						<div className="new-header__balance-block">
							<BalanceWithAccount />
						</div>
						<div
							ref={langRef}
							className="new-header__lang"
							title={tr(currentLangTitle && currentLangTitle.title)}
						>
							<button
								type="button"
								className="new-header__lang-trigger company-name"
								onClick={() => setIsLangOpen(!isLangOpen)}
								aria-expanded={isLangOpen}
								aria-haspopup="listbox"
							>
								<span className="new-header__lang-label">
									{tr(currentLangTitle && currentLangTitle.title)}
								</span>
								<img
									src={DownArrow}
									alt=""
									className={`new-header__lang-arrow ${isLangOpen ? "--open" : ""}`}
								/>
							</button>

							{isLangOpen ? (
								<div className="new-header__lang-menu" role="listbox">
									{langCodes.map(lang => (
										<button
											type="button"
											className={`new-header__lang-item ${lang.code === currentLangCode ? "--active" : ""
												}`}
											key={lang.id}
											onClick={() => {
												changeLang(lang);
												setIsLangOpen(false);
											}}
										>
											{tr(lang.title)}
										</button>
									))}
								</div>
							) : null}
						</div>
					</div>
				</div>
				{/* ) : null} */}
				{/* </div> */}
			</header>
		</>
	);
}
